import { buttonVariants } from "@car/ui/components/button";
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@car/ui/components/empty";
import { cn } from "@car/ui/lib/utils";
import { Unlink01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon, type IconSvgElement } from "@hugeicons/react";
import { Link } from "@tanstack/react-router";

import { openConsult } from "@/lib/consult";
import { MobileNavigation, SiteFooter } from "@/components/site-footer";
import { SiteHeader } from "@/components/site-header";

type NotFoundPageProps = {
  title?: string;
  description?: string;
  icon?: IconSvgElement;
};

/** صفحه ۴۰۴ سایت با سربرگ و پاورقی و راه برگشت؛ پیش‌فرض روتر و صفحه خودروی حذف‌شده */
export function NotFoundPage({
  title = "این صفحه پیدا نشد",
  description = "ممکن است نشانی اشتباه تایپ شده باشد یا صفحه جابه‌جا شده باشد.",
  icon = Unlink01Icon,
}: NotFoundPageProps) {
  return (
    <main className="min-h-[100dvh] bg-background pb-20 text-foreground md:pb-0">
      <SiteHeader />
      <div className="mx-auto max-w-[1400px] px-4 py-16 sm:px-6">
        <Empty className="border bg-card">
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <HugeiconsIcon icon={icon} strokeWidth={1.6} />
            </EmptyMedia>
            <EmptyTitle>{title}</EmptyTitle>
            <EmptyDescription>{description}</EmptyDescription>
          </EmptyHeader>
          <EmptyContent className="flex-row flex-wrap justify-center">
            <Link to="/vehicles" className={buttonVariants({ size: "lg" })}>
              دیدن همه خودروها
            </Link>
            <a href="/" className={buttonVariants({ variant: "outline", size: "lg" })}>
              صفحه اصلی
            </a>
            <button
              type="button"
              aria-haspopup="dialog"
              onClick={openConsult}
              className={cn(buttonVariants({ variant: "ghost", size: "lg" }), "text-primary")}
            >
              درخواست مشاوره
            </button>
          </EmptyContent>
        </Empty>
      </div>
      <SiteFooter />
      <MobileNavigation />
    </main>
  );
}
